import Ncert from "../components/Ncert";

const NcertPractice = () => {
  return <Ncert />;
};

export default NcertPractice;
